import type { ReactNode } from "react";

export type IconName =
  | "home"
  | "mountain"
  | "building"
  | "anchor"
  | "castle"
  | "plus"
  | "minus"
  | "x"
  | "layers"
  | "help-circle"
  | "users"
  | "user-plus"
  | "user"
  | "palette"
  | "file-text"
  | "chevron-down"
  | "chevron-left"
  | "chevron-right"
  | "arrow-left"
  | "search"
  | "ban"
  | "bed"
  | "star"
  | "share"
  | "info"
  | "eye"
  | "trash"
  | "close"
  | "chevron-up"
  | "translate"
  | "utensils"
  | "pool"
  | "heart"
  | "map-pin"
  | "sun"
  | "wine"
  | "shield-check"
  | "leaf"
  | "car"
  | "music"
  | "snowflake"
  | "run"
  | "gps"
  | "check"
  | "settings"
  | "hotel"
  | "house"
  | "landmark"
  | "plane"
  | "umbrella"
  | "shopping-bag"
  | "train"
  | "parking-circle"
  | "drop"
  | "star-smile"
  | "user-search"
  | "loader-4"
  | "pencil"
  | "lock"
  | "alert-circle"
  | "calendar"
  | "external-link"
  | "copy"
  | "globe"
  | "user-switch"
  | "mail"
  | "phone"
  | "whatsapp";

interface IconProps {
  name: IconName;
  className?: string;
  size?: number;
}

const icons: Record<IconName, ReactNode> = {
  home: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 12l8.954-8.955a1.126 1.126 0 011.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
    />
  ),
  mountain: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 17.25L9.75 3l4.5 9 3-4.5L21 17.25H3z"
    />
  ),
  building: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
    />
  ),
  anchor: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 21V9m0 12c-3.866 0-7-2.239-7-5m7 5c3.866 0 7-2.239 7-5M12 9a3 3 0 100-6 3 3 0 000 6zm0 0v3m-7 5h14"
    />
  ),
  castle: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 21v-6m0 0V9m0 6h6m-6 0H6m6-6V3m0 6h3V6h3v3h-3m-6 0H9V6H6v3h3m3 12H4.5a1.5 1.5 0 01-1.5-1.5v-3A1.5 1.5 0 014.5 15H6m6 6h7.5a1.5 1.5 0 001.5-1.5v-3a1.5 1.5 0 00-1.5-1.5H18"
    />
  ),
  plus: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
  ),
  minus: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15" />
  ),
  x: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  ),
  layers: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 2L2 7l10 5 10-5-10-5zm0 7l-10 5 10 5 10-5-10-5zm0 7l-10 5 10 5 10-5-10-5z" />
  ),
  "help-circle": (
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  ),
  users: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
    />
  ),
  "user-plus": (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.011a6.375 6.375 0 0112.75 0v.011A12.318 12.318 0 0110.375 21c-2.331 0-4.512-.645-6.374-1.766z"
    />
  ),
  palette: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.098 19.902a3.75 3.75 0 005.304 0l6.401-6.402M6.75 21A3.75 3.75 0 013 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 003.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008z"
    />
  ),
  star: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
  ),
   translate: (
    <path strokeLinecap="round" strokeLinejoin="round" d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802" />
  ),
  "file-text": (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
    />
  ),
   trash: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
  ),
  close: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  ),
  "chevron-down": (
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
  ),
  "chevron-left": (
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
  ),
  settings: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </>
  ),
  check: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
  ),
  "chevron-right": (
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
  ),
  "arrow-left": (
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
  ),
  search: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
    />
  ),
  ban: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
    />
  ),
  user: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
    />
  ),
  bed: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 7.5V18m0-4.5h18M3 13.5A2.25 2.25 0 015.25 11.25h13.5A2.25 2.25 0 0121 13.5M6.75 7.5h3.75v3.75H6.75V7.5zM13.5 7.5h3.75v3.75H13.5V7.5z"
    />
  ),
  gps: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 2v2.5m0 15V22m-10-10h2.5m15 0H22" />
    </>
  ),

  share: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"
    />
  ),
  info: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
    />
  ),
  eye: (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </>
  ),
  "chevron-up": (
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
  ),
  utensils: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M7 2v20" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
    </>
  ),
  pool: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M2 6c.6 1.4 1.6 2 3 2s2.4-.6 3-2 1.6-2 3-2 2.4.6 3 2 1.6 2 3 2 2.4-.6 3-2 1.6-2 3-2" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M2 12c.6 1.4 1.6 2 3 2s2.4-.6 3-2 1.6-2 3-2 2.4.6 3 2 1.6 2 3 2 2.4-.6 3-2 1.6-2 3-2" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M2 18c.6 1.4 1.6 2 3 2s2.4-.6 3-2 1.6-2 3-2 2.4.6 3 2 1.6 2 3 2 2.4-.6 3-2 1.6-2 3-2" />
    </>
  ),
  heart: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
  ),
  "map-pin": (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
    </>
  ),
  sun: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
  ),
  wine: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 22h8" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 10v12" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 10a4.75 4.75 0 0 0 8-8H4a4.75 4.75 0 0 0 8 8Z" />
    </>
  ),
  "shield-check": (
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M12 2.25c-5.385 1.488-8.25 4.14-8.25 10.5 0 5.485 5.097 8.232 8.25 9 3.153-.768 8.25-3.515 8.25-9 0-6.36-2.865-9.012-8.25-10.5z" />
  ),
  leaf: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M2 22l10-10" />
    </>
  ),
  car: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" />
      <circle cx="7" cy="17" r="2" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 17h6" />
      <circle cx="17" cy="17" r="2" />
    </>
  ),
  music: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 18V5l12-2v13" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="18" cy="16" r="3" />
    </>
  ),
  snowflake: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 2v20" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 22 8 18" />
      <path strokeLinecap="round" strokeLinejoin="round" d="m12 22 4-4" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 2 8 6" />
      <path strokeLinecap="round" strokeLinejoin="round" d="m12 2 4 4" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.5 17 20.5 7" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M20.5 7 19 11" />
      <path strokeLinecap="round" strokeLinejoin="round" d="m20.5 7-4-1" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.5 17 5 13" />
      <path strokeLinecap="round" strokeLinejoin="round" d="m3.5 17 4 1" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.5 7 20.5 17" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M20.5 17 19 13" />
      <path strokeLinecap="round" strokeLinejoin="round" d="m20.5 17-4 1" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.5 7 5 11" />
      <path strokeLinecap="round" strokeLinejoin="round" d="m3.5 7 4-1" />
    </>
  ),
  run: (
    <>
      <circle cx="14" cy="5" r="2" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 21l3-5-2-4 4-4 2 2 4-2" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 8l-4 2" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 16l4 2" />
    </>
  ),
  hotel: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 22v-6.57" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 11h.01" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 7h.01" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M14 15.43V22" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 16a5 5 0 0 0-6 0" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 11h.01" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 7h.01" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 11h.01" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 7h.01" />
      <rect x="4" y="2" width="16" height="20" rx="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  house: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </>
  ),
  landmark: (
    <>
      <line x1="3" x2="21" y1="22" y2="22" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="6" x2="6" y1="18" y2="11" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="10" x2="10" y1="18" y2="11" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="14" x2="14" y1="18" y2="11" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="18" x2="18" y1="18" y2="11" strokeLinecap="round" strokeLinejoin="round" />
      <polygon points="12 2 20 7 4 7" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  plane: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.2-1.1.6L3 8l6 4-3 3-3.3-1.2c-.3-.1-.7 0-1 .2L1 15l4 2 2 4 1-.7c.2-.3.3-.7.2-1L7 16l3-3 4 6l1.2-.7c.4-.2.7-.6.6-1.1Z" />
  ),
  umbrella: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M22 12a10.06 10.06 0 0 0-20 0Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 12v8a2 2 0 0 0 4 0" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 2v1" />
    </>
  ),
  "shopping-bag": (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 6h18" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 10a4 4 0 0 1-8 0" />
    </>
  ),
  train: (
    <>
      <rect width="16" height="16" x="4" y="3" rx="2" strokeLinecap="round" strokeLinejoin="round" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 11h16" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v8" />
      <path strokeLinecap="round" strokeLinejoin="round" d="m8 19-2 3" />
      <path strokeLinecap="round" strokeLinejoin="round" d="m18 22-2-3" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 15h0" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 15h0" />
    </>
  ),
  "parking-circle": (
    <>
      <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 17V7h4a3 3 0 0 1 0 6H9" />
    </>
  ),
  drop: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 2.25c-4.47 5.166-7.5 9.176-7.5 12.375a7.5 7.5 0 1015 0c0-3.199-3.03-7.209-7.5-12.375z" />
  ),
  "star-smile": (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 16s1.5 2 3 2 3-2 3-2" />
    </>
  ),
  "user-search": (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0112.5 0" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M18.5 18.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM20 20l2 2" />
    </>
  ),
  "loader-4": (
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 2v4m0 12v4M4.929 4.929l2.828 2.828m8.486 8.486l2.828 2.828M2 12h4m12 0h4M4.929 19.071l2.828-2.828m8.486-8.486l2.828-2.828" />
  ),
  pencil: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
  ),
  lock: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
  ),
  "alert-circle": (
    <>
      <circle cx="12" cy="12" r="9" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 16h.01" />
    </>
  ),
  calendar: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
    />
  ),
  "external-link": (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
    />
  ),
  copy: (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 17.25H18a2.25 2.25 0 002.25-2.25V6.108c0-.621-.504-1.125-1.125-1.125H9.375A1.125 1.125 0 008.25 6.108V8.25"
      />
    </>
  ),
  globe: (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 21a9 9 0 100-18 9 9 0 000 18z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.6 9h16.8M3.6 15h16.8M12 3c2.5 3 3.75 6 3.75 9S14.5 18 12 21c-2.5-3-3.75-6-3.75-9S9.5 6 12 3z"
      />
    </>
  ),
  "user-switch": (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.5 6.75a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zM1.5 18.75v-.375A3.375 3.375 0 014.875 15h1.5"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.5 6.75a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM22.5 18.75v-.375A3.375 3.375 0 0019.125 15h-1.5"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 12.75h7.5m0 0L13.5 10.5m2.25 2.25L13.5 15"
      />
    </>
  ),
  mail: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25H4.5a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5H4.5a2.25 2.25 0 00-2.25 2.25m19.5 0l-8.659 6.065a2.25 2.25 0 01-2.682 0L2.25 6.75"
    />
  ),
  phone: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
    />
  ),
  whatsapp: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.25 12.75c.75 1.5 2.25 2.7 3.75 3l1.5-1.5a1.5 1.5 0 011.59-.34l2.41.8a1.5 1.5 0 011.25 1.47V18a1.5 1.5 0 01-1.64 1.5A15.75 15.75 0 013 6.14 1.5 1.5 0 014.5 4.5h1.82a1.5 1.5 0 011.47 1.25l.8 2.41a1.5 1.5 0 01-.34 1.59l-1.5 1.5z"
    />
  ),
};

/** Renders a named SVG icon with configurable size and styling. */
export function Icon({ name, className = "", size = 24 }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      width={size}
      height={size}
      className={className}
    >
      {icons[name]}
    </svg>
  );
}
